import React, {Component} from "react"
import {Helmet} from "react-helmet"

class Head extends Component {
  render () {
    return (
        <div>
          <Helmet>
              <meta charset="utf-8"/>
              <title>Tab Ipsum</title>
              <meta property="og:url" content="https://tabipsum.com" />
              <meta property="og:title" content="TabIpsum" />
              <meta property="og:site_name" content="TabIpsum | Just a Lorem Ipsum Generator" />
              <meta property="og:description" content="TabIpsum is just a fancy Lorem Ipsum Generator" />
              <meta property="og:image" content="tabipsum.jpg" />
              <meta property="og:image:type" content="image/jpeg" />
              <meta property="og:image:width" content="600" />
              <meta property="og:image:height" content="315" />
              <meta property="og:image" content="tabipsum.jpg" />
              <meta property="og:image:type" content="image/jpeg" />
              <link rel="icon" href="favicon.ico" />
              <link rel="apple-touch-icon" href="apple-touch-icon.png" />
              <meta name="theme-color" content="#000000" />
          </Helmet>
      </div>
    )
  }
}

export default Head


// WEBPACK FOOTER //
// src/components/Head.jsx